import {NgModule} from "@angular/core";
import {EventsComponent} from "./events.component";
import {ListeventComponent} from "./listevent/listevent.component";
import {EventcardComponent} from "./listevent/eventcard/eventcard.component";
import {FilterEventComponent} from "./filterevent/filterevent.component";
import {AppRoutingModule} from "../../app-routing.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {SharedModule} from "../../shared/shared.module";
import {CommonModule} from "@angular/common";
import {EventRoutingModule} from "./event-routing.module";
import {EventDetailComponent} from './eventdetail/event-detail.component';
import {CreateeventComponent} from './createevent/createevent.component';
import {StepsModule} from "primeng/steps";
import {ButtonModule} from "primeng/button";
import {InputMaskModule} from "primeng/inputmask";
import {InputTextModule} from "primeng/inputtext";
import {TextareaModule} from "primeng/textarea";
import {KeyFilterModule} from "primeng/keyfilter";
import {SelectModule} from "primeng/select";
import {DatePickerModule} from "primeng/datepicker";
import {ToastModule} from "primeng/toast";
import {MenuModule} from "primeng/menu";
import {ContactrequestComponent} from './eventdetail/contactrequest/contactrequest.component';
import {PaginatorModule} from "primeng/paginator";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {
  ContactRequestListComponent
} from './eventdetail/contactrequest/contact-request-list/contact-request-list.component';
import {FileUploadModule} from "primeng/fileupload";
import {ImageModule} from "primeng/image";
import {AvatarModule} from "primeng/avatar";
import {AccordionModule} from "primeng/accordion";

@NgModule({ declarations: [
        EventsComponent,
        ListeventComponent,
        EventcardComponent,
        FilterEventComponent,
        EventDetailComponent,
        CreateeventComponent,
        ContactrequestComponent,
        ContactRequestListComponent
    ], imports: [CommonModule,
        EventRoutingModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        StepsModule,
        ButtonModule,
        InputMaskModule,
        InputTextModule,
        TextareaModule,
        KeyFilterModule,
        PaginatorModule,
        ImageModule,
        SelectModule,
        DatePickerModule,
        ConfirmDialogModule,
        InputMaskModule,
        FileUploadModule,
        ToastModule,
        MenuModule,
        AvatarModule,
        AccordionModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class EventModule {

}
